import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';

@Component({
  selector: 'app-multiple-choice',
  templateUrl: './multiple-choice.component.html',
  styleUrls: ['./multiple-choice.component.css']
})
export class MultipleChoiceComponent extends GeneralExerciseComponent {

  answers: string[] = [];
  answerType: string = "checkbox";
  solution: Set<number> = new Set();
  checkedBox: boolean[];
  checkedRadio: number;
  error: number[];

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration() {
    this.answers = this.configuration.typespecifics.answers;
    this.answerType = this.configuration.typespecifics.type;
    this.checkedBox = new Array(this.answers.length).fill(false);
    this.checkedRadio = undefined;

    // build the solution out of the solution code
    let solutionCode: string = this.configuration.typespecifics.solutionCode;
    // get number of correct solutions
    let countCorrectAnswers: number = 0;
    let primes: number[] = [7, 11, 13, 17, 19];
    for (let prime of primes) {
      if (+solutionCode.charAt(prime) % 2 == 0) {
        countCorrectAnswers++;
      } else {
        break;
      }
    }
    // get IDs of correct solutions
    for (let p of this.createArray(countCorrectAnswers)) {
      this.solution.add(+solutionCode.charAt((p + 1) * (countCorrectAnswers)));
    }
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific.checked != undefined) {
      this.checkedBox = this.state.typespecific.checked;
      this.checkedRadio = this.state.typespecific.checked;
    }
  }

  checkSolution() {
    let error = false;
    if (this.answerType == "checkbox") {
      for (let check in this.checkedBox) {
        if (this.checkedBox[check] != this.solution.has(+check)) {
          error = true;
        }
      }
    } else {
      if (!this.solution.has(this.checkedRadio)) {
        error = true;
      }
    }
    if (error) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 3000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
  }

  computeState() {
    if (this.answerType == "checkbox") {
      this.state.typespecific.checked = this.checkedBox;
    } else {
      this.state.typespecific.checked = this.checkedRadio;
    }
  }

  evaluate(): number[] {
    let result = 0;
    if (this.answerType == "checkbox") {
      for (let check in this.checkedBox) {
        if (this.checkedBox[check] == this.solution.has(+check)) {
          result++;
        }
      }
      return [result / this.answers.length, 1];
    }
    if(this.solution.has(+this.checkedRadio)){
      return [1,1];
    }
    return [0,1];
  }




}
